(function () {
  document.addEventListener('DOMContentLoaded', function () {
    const variantSelects = document.querySelector('variant-selects');
    if (!variantSelects) return;

    const chosen = new Set();
    const addBtn = document.querySelector('button[name="add"]');
    if (addBtn) addBtn.disabled = true;

    // Patch la méthode selectedOptionValues pour ignorer les non-choisis
    const originalGet = Object.getOwnPropertyDescriptor(
      Object.getPrototypeOf(variantSelects),
      'selectedOptionValues'
    );

    if (originalGet) {
      Object.defineProperty(variantSelects, 'selectedOptionValues', {
        get: function () {
          return Array.from(
            this.querySelectorAll('fieldset input:checked')
          )
            .filter(input => chosen.has(input.closest('fieldset')))
            .map(({ dataset }) => dataset.optionValueId);
        }
      });
    }

    function resetUntouched() {
      variantSelects.querySelectorAll('fieldset').forEach(fs => {
        if (!chosen.has(fs)) {
          fs.querySelectorAll('input[type="radio"]').forEach(r => {
            r.checked = false;
          });
        }
      });
    }

    // Reset en boucle au chargement pendant 1.5 secondes
    let count = 0;
    const interval = setInterval(() => {
      resetUntouched();
      if (++count >= 30) clearInterval(interval);
    }, 50);

    variantSelects.addEventListener('change', function (e) {
      const fieldset = e.target.closest('fieldset');
      if (fieldset) chosen.add(fieldset);

      setTimeout(() => {
        resetUntouched();
        const total = variantSelects.querySelectorAll('fieldset').length;
        if (addBtn) addBtn.disabled = chosen.size < total;
      }, 60);
    }, true);
  });
})();
